import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { apiMe, getToken } from "@/lib/api";
import { AUTH_EXPIRED_EVENT } from "@/lib/session";

// Server-verified admin guard. Frontend check is cosmetic; every admin API
// endpoint independently enforces the admin role server-side (403 otherwise).
export const AdminRoute = ({ children }) => {
  const [state, setState] = useState("checking"); // checking | ok | denied

  useEffect(() => {
    const check = async () => {
      if (!getToken()) { setState("denied"); return; }
      try {
        const me = await apiMe();
        setState(me?.role === "admin" ? "ok" : "denied");
      } catch {
        setState("denied");
      }
    };
    check();
    // A token rejected while this page is open ends the admin session immediately.
    const expired = () => setState("denied");
    window.addEventListener(AUTH_EXPIRED_EVENT, expired);
    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, expired);
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-300" data-testid="admin-checking">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (state === "denied") return <Navigate to="/admin/masuk" replace />;
  return children;
};
